import PortalPrograms from '@classes/Programs'
import { StoreProps } from '@interfaces/StoreState'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { LessonCountWrapper } from './style'

const LessonCount: React.FC<{ programId: string }> = ({ programId }) => {
  const StudentProgram = useSelector(({ userProfile }: StoreProps) =>
    new PortalPrograms(userProfile?.info?.StudentProfile?.StudentProfileInfo?.ProgramStudentWrappers ?? []).getProgram(
      programId
    )
  )

  if (!StudentProgram.program) {
    return null
  }

  const values = StudentProgram.program.LessonsRemaining > -1 ? StudentProgram.program.LessonsRemaining : 0

  if (StudentProgram.isFlexProgram() || StudentProgram.isBerlitzOnDemand()) {
    return null
  }

  return (
    <LessonCountWrapper>
      {StudentProgram.isProgramFinished() ? (
        <FormattedMessage id={StudentProgram.program?.Status ?? ''} />
      ) : (
        <FormattedMessage
          id="lessons-left-count"
          defaultMessage="{lessons, plural, =0 {No lessons left} one {You have # lesson left} other {You have # lessons left}}"
          values={{ lessons: values }}
        />
      )}
    </LessonCountWrapper>
  )
}

export default LessonCount
